// extracted by mini-css-extract-plugin
export default {"account_subscription_card_body":"xX","account_subscription_card_img":"yX","account_subscription_card_lower_section":"zX","account_subscription_card_category":"AX","account_subscription_card_title":"BX","account_subscription_card_price_section":"CX","account_subscription_card_servings":"EX","account_subscription_card_prices":"FX","account_subscription_card_price":"GX","account_subscription_card_price_actual":"HX"};
    if(module.hot) {
      // 1715091683812
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  